import { useNotificationState } from '@xstudios/xapp-core/foundation'

export const AUTH_HEADER_MENU_ACTIONS = {
  LOGOUT: 'logout',
}

export function buildAuthHeaderMenuItems() {
  return [
    {
      action: AUTH_HEADER_MENU_ACTIONS.LOGOUT,
      props: {
        class: 'logout-color mt-1',
        prependIcon: 'mdi-subdirectory-arrow-right',
      },
      title: 'Logout',
      value: AUTH_HEADER_MENU_ACTIONS.LOGOUT,
    },
  ]
}

export async function handleAuthHeaderMenuAction(action, context = {}) {
  const { clearNotifications, notify } = useNotificationState()
  const { authStore, meStore, onLogoutError, onLogoutSuccess, router } = context

  if (action !== AUTH_HEADER_MENU_ACTIONS.LOGOUT) {
    return false
  }

  try {
    await authStore?.logout?.()
    meStore?.clear?.()
    clearNotifications()
    notify({
      color: 'success',
      text: 'Logged out successfully.',
    })
    if (typeof onLogoutSuccess === 'function') {
      await onLogoutSuccess({ action, context })
    }
  } catch (error) {
    notify({
      color: 'error',
      text: error?.response?.data?.detail || 'Failed to Logout.',
    })
    if (typeof onLogoutError === 'function') {
      await onLogoutError({ action, context, error })
    }
  }

  if (router?.replace) {
    await router.replace('/login')
  }
  return true
}
